import { Theme, useMediaQuery } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import React, { useEffect } from 'react';
import { useLayoutContext } from '../useLayoutContext';

export const DRAWER_WIDTH = 320;

const MainDrawer = () => {
  const { drawerContent, drawerFooter, drawerOpen, setDrawerOpen } = useLayoutContext();
  const matchDownMD = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const variant = matchDownMD ? 'temporary' : 'permanent';

  useEffect(() => {
    setDrawerOpen(!matchDownMD);
  }, [matchDownMD, setDrawerOpen]);

  return (
    <Drawer
      variant={variant}
      open={drawerOpen}
      onClose={() => setDrawerOpen(!drawerOpen)}
      sx={{
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: DRAWER_WIDTH,
          borderRight: '1px solid',
          borderRightColor: 'divider',
          backgroundImage: 'none',
          boxShadow: 'inherit',
          scrollbarWidth: 'none',
        },
      }}
    >
      {drawerContent}
      {drawerFooter}
    </Drawer>
  );
};

export default MainDrawer;
